export default function initNavbarScroll() {
    document.addEventListener('DOMContentLoaded', () => {
        let lastScrollTop = 0;
        const delta = 10;
        const navbar = document.getElementById("main-nav");
        let didScroll;

        if (!navbar) return;

        window.addEventListener("scroll", function () {
            didScroll = true;
        });

        setInterval(function () {
            if (didScroll) {
                hasScrolled();
                didScroll = false;
            }
        }, 250);

        function hasScrolled() {
            const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

            if (Math.abs(lastScrollTop - currentScroll) <= delta) return;

            if (currentScroll > lastScrollTop && currentScroll > navbar.offsetHeight) {
                navbar.classList.add("nav-hide");
            } else {
                navbar.classList.remove("nav-hide");
            }

            lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
        }
    });
}
